import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { Settings } from '../../../core';
import { FilterFieldValue } from '../../../covance-filter';
import { DocumentFilterItem, DocumentFilterItemReadModel } from '../../../documents/document-filter-item';
import { prepareFilterUrlParams } from '../../../documents/prepare-filter-url-params';
import { AdminEmailNotificationAlertReport, AdminEmailNotificationAlertReportReadModel } from '../report-types/admin-activity-report-email-notification-alert';


@Injectable()
export class AdminEmailAlertsStorage {
    constructor(
        private http: HttpClient,
        private settings: Settings
    ) { }

    public getReports(userPk: number, filterParameters: FilterFieldValue[] = null): Observable<AdminEmailNotificationAlertReport[]> {
        let filtersParams = prepareFilterUrlParams(filterParameters);

        return this.http.get(`${this.settings.apiUrl}/admin/activity-reports/email-alerts/${encodeURI(userPk.toString())}`, { params: filtersParams }).pipe(
            map((reports) => deserialize(reports, AdminEmailNotificationAlertReportReadModel).reports)
        );
    }

    public loadEmailNotificationAlertsFilterItems(userPk: number): Observable<DocumentFilterItem[]> {
        return this.http.get(
            `${this.settings.apiUrl}/admin/activity-reports/email-alerts/${encodeURI(userPk.toString())}/filter-items`
        ).pipe(
            map((r) => deserialize(r, DocumentFilterItemReadModel).documentFilterItems)
        );
    }
}
